import React, { useEffect, useState } from 'react';
import { Balloon, Avatar } from '@alifd/next';
import { isLogin, LOGIN_LINK, logOut } from '@/utils/login';
import { request } from '@/utils/request';
import { parseImage } from '@/utils/media-transfer';
import dsi18n from '@/i18n/ds';
import { DotElement, dotSceneNameMap } from '@/components/dots';
import './index.scss';

const headerScene = dotSceneNameMap.header;

function SaasAvatar({ logOutLink }: { logOutLink?: string }) {
  const [account, setAccount] = useState({
    avatar: '',
    name: '',
    email: '',
  });

  const fetchAccount = async () => {
    const res = await request('//dropshipping.alibaba.com/saas/ajax/query_account');
    res.data && setAccount(res.data);
  };

  useEffect(() => {
    isLogin() && fetchAccount();
  }, []);
  return (
    <div className="saas-header-action saas-avatar-wrapper">
      {isLogin() ? (
        <Balloon
          className="saas-header-ballon"
          trigger={
            account.avatar ? (
              <img
                className="saas-avatar"
                src={parseImage({ img: account.avatar, size: 80 })}
                alt={account.name}
              />
            ) : (
              <Avatar icon="account" />
            )
          }
          triggerType="hover"
          closable={false}
        >
          <a
            className="saas-account-info"
            href="https://usmy.alibaba.com/user/account_settings.htm"
          >
            <div className="saas-account-name color3" lines="1" title={account.name}>
              {account.name}
            </div>
            <div className="saas-account-email color6">{account.email}</div>
          </a>
          <hr />
          <DotElement
            dotParams={{ scene: headerScene, action: 'logout' }}
            elementTag="a"
            url={logOut(logOutLink)}
            target="_self"
            className="saas-account-log-out color0"
          >
            {dsi18n('SignOut')}
          </DotElement>
        </Balloon>
      ) : (
        <DotElement
          dotParams={{ scene: headerScene, action: 'login' }}
          elementTag="a"
          url={LOGIN_LINK}
          target="_self"
          className="saas-account-log-in color3"
        >
          {dsi18n('Signin')}
        </DotElement>
      )}
    </div>
  );
}

export default SaasAvatar;
